// extracted by mini-css-extract-plugin
export default {"Preloader":"Preloader_Preloader__1pDKO","Preloader__spinner":"Preloader_Preloader__spinner__22jUe","spin":"Preloader_spin__3rda9"};